/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Summary_TitleInputs */

const en_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration Summary`)
};

const fr_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé de la configuration`)
};

const de_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurationsübersicht`)
};

const it_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo della configurazione`)
};

const ru_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сводка по конфигурации`)
};

const es_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de configuración`)
};

const zh_cn2_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置摘要`)
};

const ja_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`構成の概要`)
};

const hi_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉन्फ़िगरेशन सारांश`)
};

const pt_pt2_options_cli_summary_title = /** @type {(inputs: Options_Cli_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo da configuração`)
};

/**
* | output |
* | --- |
* | "Configuration Summary" |
*
* @param {Options_Cli_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_summary_title = /** @type {((inputs?: Options_Cli_Summary_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Summary_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_summary_title(inputs)
	if (locale === "de") return de_options_cli_summary_title(inputs)
	if (locale === "it") return it_options_cli_summary_title(inputs)
	if (locale === "ru") return ru_options_cli_summary_title(inputs)
	if (locale === "es") return es_options_cli_summary_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_summary_title(inputs)
	if (locale === "ja") return ja_options_cli_summary_title(inputs)
	if (locale === "hi") return hi_options_cli_summary_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_summary_title(inputs)
	return en_options_cli_summary_title(inputs)
});